export const TOS = "https://www.merits.com/legal/terms-of-service";
export const PRIVACY = "https://www.merits.com/legal/privacy-notice";
export const HELP = "https://knowledge.merits.com/";
